import React, { useEffect, useLayoutEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import { getABParticipationStatus } from '../../../app/functions';

const Bot = () => {
  const userData = useSelector((store) => store.config.UserData);
  const { botConfiguration } = useSelector((store) => store.config.Parameters);
  const { mainConfiguration, abTestingPercentage } = botConfiguration;

  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(forceUpdate, [userData, botConfiguration]);

  useLayoutEffect(() => {
    if (
      !mainConfiguration ||
      !getABParticipationStatus('botABTestingIncluded', abTestingPercentage)
    ) return;

    const parsedConfiguration = JSON.parse(mainConfiguration);
    const { src = '', attributes = {} } = parsedConfiguration;
    const { accessToken = '' } = userData;
    const script = document.createElement('script');

    script.setAttribute('type', 'module');
    script.setAttribute('src', src);
    if(accessToken){
    script.setAttribute('token', accessToken);
    }

    for (const key in attributes) {
      script.setAttribute(key, attributes[key]);
    }

    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, [userData, botConfiguration]);

  return null;
};

export default Bot;
